import { useEffect, useState } from 'react';
import { Alert, Anchor } from '@mantine/core';
import { ANNOUNCEMENT_CONFIG } from '../../config/announcement';
import './Announcement.css';

const ANNOUNCEMENT_DISMISSED_KEY = 'announcement_dismissed_time';

const Announcement = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // If announcement is disabled, don't show it
        if (!ANNOUNCEMENT_CONFIG.enabled) {
            setIsVisible(false);
            return;
        }

        // Check if announcement was recently dismissed
        const lastDismissedTime = localStorage.getItem(ANNOUNCEMENT_DISMISSED_KEY);
        const currentTime = Date.now();
        
        if (lastDismissedTime && currentTime - parseInt(lastDismissedTime) < ANNOUNCEMENT_CONFIG.reappearDelay) {
            setIsVisible(false);
            return;
        }

        // Show announcement
        setIsVisible(true);
    }, []); // Empty dependency array - only run on mount

    if (!isVisible || !ANNOUNCEMENT_CONFIG.enabled) return null;

    const handleClose = () => {
        setIsVisible(false);
        // Store the current time when announcement was dismissed
        localStorage.setItem(ANNOUNCEMENT_DISMISSED_KEY, Date.now().toString());
    };

    return (
        <div className="announcement-container">
            <Alert
                className="announcement"
                color={ANNOUNCEMENT_CONFIG.type}
                withCloseButton
                closeButtonLabel="Close announcement"
                onClose={handleClose}
                variant="gradient"
                gradient={ANNOUNCEMENT_CONFIG.style.gradient}
                styles={{
                    root: {
                        backgroundColor: ANNOUNCEMENT_CONFIG.style.backgroundColor,
                    },
                    message: {
                        color: ANNOUNCEMENT_CONFIG.style.textColor,
                        fontSize: ANNOUNCEMENT_CONFIG.style.fontSize,
                        fontWeight: ANNOUNCEMENT_CONFIG.style.fontWeight,
                    },
                    closeButton: {
                        color: ANNOUNCEMENT_CONFIG.style.textColor,
                        '&:hover': {
                            backgroundColor: 'rgba(255, 255, 255, 0.1)',
                        },
                    },
                }}
            >
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px' }}>
                    {ANNOUNCEMENT_CONFIG.message}
                    {ANNOUNCEMENT_CONFIG.link.enabled && (
                        <Anchor 
                            href={ANNOUNCEMENT_CONFIG.link.url}
                            style={{
                                ...ANNOUNCEMENT_CONFIG.link.style,
                                textDecoration: 'none',
                            }}
                            className="announcement-link"
                        >
                            {ANNOUNCEMENT_CONFIG.link.text}
                        </Anchor>
                    )}
                </div>
            </Alert>
        </div>
    );
};

export default Announcement; 